// extracted by mini-css-extract-plugin
module.exports = {"hideTooltip":"fu","fadeIn":"gu","delay":"hu","recommendedSizeTooltip":"iu"};